import EA from '../helpers/init';

export default EA.Methods.openMenu = ($this) => {
    const menuWrapper = $this;
    const mobileMenu = document.querySelector('.mobile-menu');

    menuWrapper.addEventListener('click', () => {
        menuWrapper.classList.toggle('active');
        mobileMenu.classList.toggle('active');
    });
};
